import React from 'react';
import { Link } from 'react-router-dom';

export default function Termsandcondition() {
    const sattaName =" A-71 satta";
    // alert(sattaName)
    const sattaWebsite = "https://a-71ajsatta.com";

    return (
        <div>
            <section className="textcenter">
                        <div className="text-center">
                            <h1 className='text-white'>
                                <Link to="https://a-71ajsatta.com" className="blink text-white">
                                      {sattaWebsite}  
                                </Link>
                            </h1>
                        </div>
               
            </section>
            <div className="satta-container">
                <div className="satta-inner">
                    <marquee className="satta-marquee">
                        A-71 SATTA| Satta Game | Satta Result | Satta Record Chart | Gali Desawar Gaziabad Gazipur | Satta Number | Today Satta Result
                         | Fix Leak Satta Company Number | Superfast Satta Result | Live Satta Result | Satta Lucky Number | Satta Bazaar | Kalyan Milan 
                         Main Mumbai | Matka Reults | Satta Matka Results |
                    </marquee>
                </div>
            </div>
            <div className="terms-conditions">
                <h1 className="main-heading">Terms and Conditions for {sattaName}</h1>

                <p className="content">
                    Welcome to {sattaName}, accessible from <a href={sattaWebsite}>{sattaWebsite}</a>. These terms and conditions outline the rules and regulations for the use of 
                    {sattaName}'s website.
                </p>

                <p className="content">
                    By accessing this website, we assume you accept these terms and conditions. Do not continue to use {sattaName} if you do not agree to take all of the terms and conditions stated on this page.
                </p>

                <h2 className="sub-heading">Intellectual Property</h2>

                <p className="content">
                    Unless otherwise stated, {sattaName} and/or its licensors own the intellectual property rights for all material on {
                    sattaName}. All intellectual property rights are reserved. You may access this from {sattaName} for your own personal use subjected to restrictions set in these terms and conditions.
                </p>

                <h2 className="sub-heading">User Responsibilities</h2>

                <p className="content">
                    As a user of this website, you agree to use it only for lawful purposes and in a way that does not infringe the rights of or restrict the use and enjoyment of this website by any third party. Users are prohibited from transmitting, distributing, or storing any material that is obscene, offensive, or in violation of any applicable laws.
                </p>

                <h2 className="sub-heading">Disclaimers</h2>

                <p className="content">
                    The information on this website is provided "as is" and {sattaName} makes no representations or warranties of any kind, express or implied, regarding the accuracy or completeness of the information provided on this site. We will not be liable for any errors or omissions in the content, or for any losses, injuries, or damages arising from the use of this site.
                </p>

                <h2 className="sub-heading">Limitation of Liability</h2>

                <p className="content">
                    In no event shall {sattaName} be liable for any damages, including but not limited to indirect, special, incidental, or consequential damages, or any damages whatsoever arising from the use of this website or its contents, even if {sattaName} has been advised of the possibility of such damages.
                </p>

                <h2 className="sub-heading">Third-Party Links</h2>

                <p className="content">
                    Our website may contain links to third-party websites or services that are not owned or controlled by {sattaName}. We do not assume responsibility for the content, privacy policies, or practices of third-party sites. You acknowledge and agree that {sattaName} will not be responsible or liable for any damage or loss caused or alleged to be caused by or in connection with the use of any such content, goods, or services available on or through any third-party websites.
                </p>

                <h2 className="sub-heading">Modifications to Terms</h2>

                <p className="content">
                    {sattaName} reserves the right to revise and update these terms and conditions at any time. By continuing to use this website after any modifications to these terms, you accept those changes and agree to be bound by the revised terms.
                </p>

                <h2 className="sub-heading">Governing Law</h2>

                <p className="content">
                    These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction where {sattaName} operates, and you submit to the exclusive jurisdiction of the courts in that location for the resolution of any disputes.
                </p>

                <h2 className="sub-heading">Consent</h2>

                <p className="content">
                    By using our website, you hereby consent to our Terms and Conditions and agree to abide by them.
                </p>
            </div>
        </div>
    );
}
